import moment from 'moment';

export const convertDate = (d: moment.Moment | null) => {
  try {
    return d?.format('YYYY-MM-DD');
  } catch (e) {}
  return d;
};
